import React from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../Hooks";
import useWindowDimensions from "../../Hooks/UseWindowDiemensions";

import useStyles from "./FmPageTitle.style";

interface FmPageTitleProps {
    title: string;
}

const FmPageTitle = ({ title }: FmPageTitleProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    if (isMobile) {
        return (
            <div className={classes.container}>
                <span className={classes.mobile_title}>{title}</span>
            </div>
        );
    }

    return (
        <div className={classes.container}>
            <span className={classes.bold_title}>{t("agriSolution.title")}</span>
            <span className={classes.right_title}> / {title}</span>
        </div>
    );
};

export default FmPageTitle;
